import { RawDataSource } from '@felicity/data-management';

/**
 * Data source for loading and storing assessors
 */
export default class AssistantDataSource extends RawDataSource {
  uri = '/api/Users/Profile/Selector';
  sortField = 'name';

  /**
   *
   */
  constructor() {
    super();

    this.setFilter('role', 'assistant');
  }
}
